import {Box, Typography} from "@mui/material";
import {FC} from "react";
import {AppBarComponent} from "../../components/AppBar/AppBarComponent";
import {useTranslation} from "react-i18next";

export const PrivacyPolicy: FC = () => {
  const {t} = useTranslation();
  return (
    <Box>
      <AppBarComponent/>
      <Typography mx={2} variant="h3">{t('privacy.policy.title')}</Typography>
      <Box sx={{m: 2}}>
        <Typography>{t('privacy.policy.subtitle')}</Typography>
        <Typography style={{whiteSpace: 'pre-line'}}>{t('privacy.policy.text')}</Typography>
      </Box>
    </Box>
  );
};
